<template>
  <div>
    <b-form id="alter-form" class="alter-form" @submit="onSubmit">
      <b-card class="custom-card" border-variant="light">
        <b-form-row>
          <b-col>
            Tipo
          </b-col>
          <b-col>
            <b-form-select
              v-model.lazy.trim="form.fileType"
              :state="validateField('fileType')"
              :options="fileTypeOptions"
              v-on:change="onChangeFileType"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            Competência
          </b-col>
          <b-col>
            <custom-mask-input
              :initialValue="form.competency"
              :options="monthYearDateMask"
              :state="validateFieldLength('competency', 7)"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <UploadFile
              ref="upload-file-component"
              accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @updateFile="eventToUpdateFile"
              description="Anexar documento para comprovação"
              msgErro="É necessário inserir um anexo com a comprovação."
              :state="validateFieldFile('files')"
              :required="true"
            />
          </b-col>
        </b-form-row>
      </b-card>
      <b-button
        form="alter-form"
        type="submit"
        class="mt-4"
        variant="primary"
        id="submitButtonText"
      >
        Enviar
      </b-button>
    </b-form>
  </div>
</template>

<script>
import UploadFile from "../../../../components/upload-file/UploadFile.vue";
import {
  validateField,
  requiredFieldsFilled,
  validateFieldFile,
} from "../../../../utils/validate/validate.js";
import { DocumentType } from "../../../../static-data/DocumentType";
import CustomMaskInput from "../../../../components/forms/custom-mask-input/CustomMaskInput.vue";

const InvalidEventHandler = () => {
  console.warn("Invalid onChange handler");
};

const MonthYearDateMask = {
  date: true,
  delimter: "/",
  datePattern: ["m", "Y"],
  onValueChanged: InvalidEventHandler,
};

const YearOnlyMask = {
  numericOnly: true,
  blocks: [4],
  onValueChanged: InvalidEventHandler,
};

const DefaultForm = {
  fileType: null,
  crm: null,
  competency: null,
  files: null,
};

export default {
  props: ["onSubmitHandler"],
  components: { UploadFile, CustomMaskInput },
  mounted() {
    this.initFileTypeOptions();
  },
  computed: {
    DocumentType() {
      return DocumentType;
    },
  },
  data() {
    return {
      fileTypeOptions: [],
      formSubmited: false,
      form: {
        ...DefaultForm,
        fileType: DocumentType.SUPPORT_FUND,
      },
      yearOnlyMask: {
        ...YearOnlyMask,
        onValueChanged: this.onChangeCompetency,
      },
      monthYearDateMask: {
        ...MonthYearDateMask,
        onValueChanged: this.onChangeCompetency,
      },
      validations: {},
      validateField,
      requiredFieldsFilled,
      validateFieldFile,
    };
  },
  methods: {
    validateFieldLength(name, requiredLength) {
      let value = this.form[name];
      let validation = true;
      validation = !!value;
      validation = validation && value.length == requiredLength;

      this.validations[name] = validation;
      if (!this.formSubmited) return null;

      return validation;
    },
    initFileTypeOptions() {
      this.fileTypeOptions = [
        {
          text: "Fundo de Sustentabilidade",
          value: DocumentType.SUPPORT_FUND,
        },
      ];
    },
    onChangeFileType() {
      this.$refs["upload-file-component"].removeAllFiles();
    },
    onChangeCompetency(e) {
      this.form.competency = e.target.value;
    },
    eventToUpdateFile(files) {
      this.form.files = files;
    },
    onSubmit(e) {
      e.preventDefault();
      this.formSubmited = true;
      if (this.requiredFieldsFilled()) {
        this.$props.onSubmitHandler(this.form);
        this.formSubmited = false;
        this.$refs["upload-file-component"].removeAllFiles();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div.custom-card {
  padding: 0 !important;
}

div.form-row {
  padding: 0.5rem;
  border-bottom: 1px solid $gray-300;
  &:last-child {
    border-bottom: none;
  }
}

input.form-control {
  text-align: right;
  border: 1px solid transparent;
}

select.custom-select {
  text-align: right;
  border: 1px solid transparent;
}
</style>
